export default __webpack_public_path__ + "static/media/gwn39.5c24820d.webp";